/**
 * Extracts the full country name from an address using Google's Geocoding API
 * @param {string} address - The address to geocode
 * @returns {Promise<string|null>} - The full country name or null if not found
 */
export async function getCountryNameFromAddress(address) {
    const apiKey = import.meta.env.VITE_GOOGLE_API_KEY
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${apiKey}`

    try {
        const response = await fetch(url)
        const data = await response.json()

        if (data.status === 'OK') {
            const addressComponents = data.results[0].address_components
            for (const component of addressComponents) {
                if (component.types.includes('country')) {
                    return component.long_name // Use long_name for full country name instead of short_name
                }
            }
        } else {
            console.error('Geocoding API error:', data.status)
            return null
        }
    } catch (error) {
        console.error('Error fetching geocoding data:', error)
        return null
    }
}

/**
 * Extracts the country code from an address using Google's Geocoding API
 * @param {string} address - The address to geocode
 * @returns {Promise<string|null>} - The country code or null if not found
 */
export async function getCountryCodeFromAddress(address) {
    const apiKey = import.meta.env.VITE_GOOGLE_API_KEY
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${apiKey}`

    try {
        const response = await fetch(url)
        const data = await response.json()

        if (data.status === 'OK') {
            const addressComponents = data.results[0].address_components
            for (const component of addressComponents) {
                if (component.types.includes('country')) {
                    return component.short_name // Use short_name for country code
                }
            }
        } else {
            console.error('Geocoding API error:', data.status)
            return null
        }
    } catch (error) {
        console.error('Error fetching geocoding data:', error)
        return null
    }
}
